import store from '@/store'
const STORAGE_LANG = '_lang'
export function getStorageLang():string | null{
    return localStorage.getItem(STORAGE_LANG)
}

export function setStorageLang(lang):void{
    localStorage.setItem(STORAGE_LANG, lang)
}

export function getBrowserlang(){
    var lang = navigator.language
    if(lang.startsWith('zh')){
        return 'zh-CN'
    }
    if(lang.startsWith('en')){
        return 'en-US'
    }
    return lang
}

export function getStorelang(){
    const lang = store && store.state && store.state.app && store.state.app.locale
    return lang
}

export function getlang(){
    return getStorageLang() || getStorelang() || getBrowserlang()
}
